import { useAurigaContext } from '@context/AurigaContext';
import { Box } from '@mui/material';
import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

interface SystemAlertsWrapperProps {
  children: ReactNode;
}

/**
 * Wrapper component that renders system alerts inline above the wrapped content
 * Used at the route level to show alerts specific to that route
 */
const SystemAlertsWrapper = ({ children }: SystemAlertsWrapperProps) => {
  const location = useLocation();
  const { renderAlerts } = useAurigaContext();

  return (
    <Box>
      {renderAlerts(location.pathname)}
      {children}
    </Box>
  );
};

export default SystemAlertsWrapper;
